<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>What is This Thing Called Love?</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<h2 class="h2">Contents</h2>
<p class="content1"><em class="italic"><a href="#/xhtml/prelude">Prelude</a></em></p>
<p class="content"><a href="#/xhtml/chapter01">The Birthday</a></p>
<p class="content1"><span href="#/xhtml/chapter02" title="Link target outside of Sample">In Love for the First Time</span></p>
<p class="content1"><span href="#/xhtml/chapter03" title="Link target outside of Sample">The Lady with the Red Hat</span></p>
<p class="content1"><span href="#/xhtml/chapter04" title="Link target outside of Sample">The Flirt</span></p>
<p class="content1"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Are You Really in Love</span></p>
<p class="content1"><span href="#/xhtml/chapter06" title="Link target outside of Sample">My Old Flame</span></p>
<p class="content1"><span href="#/xhtml/chapter07" title="Link target outside of Sample">The Anniversary</span></p>
<p class="content1"><span href="#/xhtml/chapter08" title="Link target outside of Sample">Tango Without Music</span></p>
<p class="content1"><span href="#/xhtml/chapter09" title="Link target outside of Sample">The King of Hearts</span></p>
<p class="content1"><span href="#/xhtml/chapter10" title="Link target outside of Sample">The Kiss</span></p>
<p class="content1"><span href="#/xhtml/chapter11" title="Link target outside of Sample">The Hollywood Producer</span></p>
<p class="content1"><span href="#/xhtml/chapter12" title="Link target outside of Sample">Passion</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?9ac4b72e